import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SurveyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18 1a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 013-3h12zm0 2H6a1 1 0 00-1 1v16a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1zm-7.735 12.322a1 1 0 111.47 1.356l-2.77 3a1 1 0 01-1.49-.023l-1.23-1.418a1 1 0 011.51-1.31l.499.574zm1.413-5.557a1 1 0 01.136 1.316l-.08.097-2.768 3a1 1 0 01-1.402.067l-.088-.09-1.231-1.418a1 1 0 011.422-1.4l.088.09.499.574 2.011-2.18a1 1 0 011.413-.056zm0-5.5a1 1 0 01.136 1.316l-.08.097-2.768 3a1 1 0 01-1.402.067l-.088-.09-1.231-1.418a1 1 0 011.422-1.4l.088.09.499.574 2.011-2.18a1 1 0 011.413-.056z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
SurveyIcon.isCarinaIcon = true;
export default SurveyIcon;
